import {useQuery} from '@tanstack/react-query';
import {API, GetGuruWalkToursParams, GuruWalkTour} from '@chekin/api';
import {QUERY_CACHE_KEYS} from '@chekin/core';

const CACHE_TIME = 60_000;
const STALE_TIME = 60_000;

function useFetchGuruWalkTours({
  locality,
  language,
  country,
  checkIn,
  checkOut,
  limit,
}: GetGuruWalkToursParams) {
  return useQuery({
    queryKey: [
      QUERY_CACHE_KEYS.guruWalkTours,
      locality,
      language,
      country,
      checkIn,
      checkOut,
      limit,
    ],
    queryFn: () =>
      API.upselling.getGuruWalkTours({
        locality,
        language,
        country,
        checkIn,
        checkOut,
        limit,
      }),
    enabled: Boolean(locality && language && country && checkIn && checkOut),
    staleTime: STALE_TIME,
    gcTime: CACHE_TIME,
  });
}

export {useFetchGuruWalkTours};
export type {GuruWalkTour};
